// extracted by mini-css-extract-plugin
export default {"left":"SeriesTabs_left__ItCNj"};